import {
  Component,
  Input,
  ElementRef,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { TranslocoService } from '@ngneat/transloco';

import { Store } from '@ngrx/store';

import { WidgetBaseComponent } from '../../../models/widget';
import { Events } from '../../../services/events.service';
import { HestiaQnrFormSessionService } from '../../../services/qnr-form-session.service';
import { StringWidgetConfig } from './string-widget.config';

@Component({
  selector: 'hestia-string-widget',
  templateUrl: './string-widget.component.html',
  styleUrls: ['./string-widget.component.scss'],
})
export class StringWidgetComponent
  extends WidgetBaseComponent
  implements OnInit, OnDestroy
{
  @Input() config: StringWidgetConfig;
  @Input() form: UntypedFormGroup;
  constructor(
    transloco: TranslocoService,
    questionnaireService: HestiaQnrFormSessionService,
    store: Store,
    element: ElementRef,
    events: Events
  ) {
    super(transloco, questionnaireService, store, element, events);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  get isValid() {
    return this.form.controls[this.config.name].valid;
  }

  updateFormValue(value) {
    this.form.controls[this.config.name].setValue(value);
  }

  newVirtualKeyboardValue(value) {
    this.updateFormValue(value);
  }
}
